import { createSlice } from "@reduxjs/toolkit";
import { HelpReducer } from "src/pages/DashboardPage/vpo/types/state";

const initialState: HelpReducer = {
  data: {
    contacts: [],
    instructions: [],
  },
  fetchingStatusHelp: false,
  error: null,
};

export const help = createSlice({
  name: "GOS_Help",
  initialState,
  reducers: {
    fetchHelpInfoRequest: (state) => {
      state.fetchingStatusHelp = true;
      state.error = null;
    },
    fetchHelpInfoSuccess: (state, action) => {
      state.fetchingStatusHelp = false;
      state.data = action.payload;
    },
    fetchHelpInfoFailure: (state, action) => {
      state.fetchingStatusHelp = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchHelpInfoRequest,
  fetchHelpInfoSuccess,
  fetchHelpInfoFailure,
} = help.actions;
